import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import InputUpload from '../../components/Inputs/InputUpload'
import Select from '../../components/Inputs/Select'

const InfoAccount : React.FC<IInfoAccount> = ({tenatUser, onCancel, onSubmit, children, isLoading = false }) => {

  const [imageKYC, setImageKYC] = useState<any>(null)

    const docs = [
        {
          value: 'V',
          text: 'V',
        },
        {
          value: 'J',
          text: 'J',
        },
        {
          value: 'E',
          text: 'E',
        },
        {
          value: 'P',
          text: 'P',
        },
        {
          value: 'G',
          text: 'G',
        },
        {
          value: 'C',
          text: 'C',
        },
      ]

      const states = [
        { text: 'Amazonas', value: 'amz' },
        { text: 'Anzoátegui', value: 'anz' },
        { text: 'Apure', value: 'apr' },
        { text: 'Aragua', value: 'arg' },
        { text: 'Barinas', value: 'barn' },
        { text: 'Bolívar', value: 'blv' },
        { text: 'Carabobo', value: 'cara' },
        { text: 'Cojedes', value: 'coje' },
        { text: 'Delta Amacuro', value: 'delt' },
        { text: 'Distrito Capital', value: 'dist' },
        { text: 'Falcón', value: 'falc' },
        { text: 'Guárico', value: 'guar' },
        { text: 'Lara', value: 'lar' },
        { text: 'Mérida', value: 'mer' },
        { text: 'Miranda', value: 'mir' },
        { text: 'Monagas', value: 'mon' },
        { text: 'Nueva Esparta', value: 'nuev' },
        { text: 'Portuguesa', value: 'por' },
        { text: 'Sucre', value: 'sucr' },
        { text: 'Táchira', value: 'tac' },
        { text: 'Trujillo', value: 'tru' },
        { text: 'Vargas', value: 'var' },
        { text: 'Yaracuy', value: 'yar' },
        { text: 'Zulia', value: 'zl' }
      ]

  const getState = () => {
    return states.find(state => state?.text === tenatUser?.address?.state)
  }

  const getDoc = () => {
    return docs.find(doc => doc?.text === tenatUser?.document?.documentType)
  }

  const form = useForm({
    defaultValues: {
      ...tenatUser,
      phone: `0${tenatUser?.phone.slice(3)}`,
      address: {
        ...tenatUser.address,
        state: getState()?.value
      }
    }
  })

  const [image, setImage] = useState()

  const [imageToDelete, setImageToDelete] = useState('')

//   const getDoc = () => {
//     let doc = docs.find((d) => d.value === defaultValues.documentType)
//     return doc
//   }

  const onSubmitForm = (values: any) => {

    if (!/^(^(0412|0414|0416|0424)\d{7})$/.test(values?.phone)) {
      form.setError('phone', {message: 'Formato de número telefónico inválido'})
      return
    }

    let newPhone = `+58${values?.phone.slice(1)}`

    onSubmit({...values, phone: newPhone, imageKYC})
  }

  return (
    <Form form={form} onSubmit={(values) => onSubmitForm({...values, image, imageToDelete, address: {
      ...values.address,
      state: states.find(state => state.value === values?.address?.state)?.text,
    }})} classes={`grid grid-cols-12 gap-4`}>
      <h2 className="text-primary-900 font-bold dark:text-white mb-5 col-span-12">
        Información de cuenta
      </h2>

      <div className='lg:col-span-3 col-span-12 row-span-3'>
        <InputUpload
          value={tenatUser.image === " " ? undefined : tenatUser.image}
          title='Sube el logo de tu empresa'
            fileType="image"
            handleImage={(img) => {
                setImage(img)
            }}
            deleteImage={() => {
              setImageToDelete(
                tenatUser?.image
              )
              setImage(undefined)
            }}
            containerClasses="xl:col-start-1 xl:row-span-3 xl:col-span-3 col-start-3 col-span-8 row-span-8 m-auto"
            imageClasses="rounded-md dark:border-gray-700"
          />
        </div>

      <FormItem
          name="businessSocial"
          classes="lg:col-span-5 col-span-12 lg:col-start-4"
          rules={{ required: 'Es necesario una razón social' }}
        >
          <InputText small label="Razón Social" />
        </FormItem>

        <FormItem
          name="businessName"
          classes="lg:col-span-4 col-span-12"
          rules={{ required: 'Ingrese su nombre' }}
        >
          <InputText small label="Nombre comercial" />
        </FormItem>


        <FormItem
          name="document.documentType"
          defaultValue={getDoc()}
          rules={{ required: 'Es necesario el campo' }}
          classes="lg:col-span-5 col-span-12 lg:col-start-4"
        >
          <Select
            options={docs}
            setSelectedHelper={async (v) => {
            }}
            label="Tipo"
          />
        </FormItem>

        <FormItem
          name="document.document"
          classes="lg:col-span-4 col-span-12"
          rules={{
            required: 'Es necesario el documento',
            pattern: { value: /^\d+$/, message: 'Documento inválido' },
            minLength: {
              value: 6,
              message: 'El documento debe de poseer al menos 6 caracteres.',
            },
          }}
        >
          <InputText isUpperValue={false}
            label="Documento"
            maxLength={15}
          />
        </FormItem>

        
        <FormItem
          name="address.address"
          classes="lg:col-span-5 col-span-12 lg:col-start-4"
          rules={{ required: 'Campo obligatorio' }}
        >
          <InputText small label="Dirección" />
        </FormItem>

        <FormItem
          name="phone"
          classes="lg:col-span-4 col-span-12"
        >
          <InputText small label="Teléfono (Ej: 04121111111)" />
        </FormItem>


        <FormItem
          name="address.state"
          classes="lg:col-span-5 col-span-12 lg:col-start-4"
          rules={{ required: 'Campo obligatorio' }}
          defaultValue={getState()}
        >
           <Select
            options={states}
            setSelectedHelper={async (v) => {
            
            }}
            label="Estado"
          />
        </FormItem>

        <FormItem
          name="address.city"
          classes="lg:col-span-4 col-span-12"
          rules={{ required: 'Ingrese su ciudad' }}
        >
            <InputText small label="Ciudad" />
        </FormItem>

        <FormItem
          name="address.postalCode"
          classes="lg:col-span-5 col-span-12 lg:col-start-4"
        >
            <InputText small label="Código Postal (opcional)" />
        </FormItem>

        
        <div style={{height: 1, width: '100%', backgroundColor: '#CFCFCF'}} className="col-span-12 mt-3"></div>

        {/* <div className='col-span-12'>
          {children}
        </div> */}


        {/* <div style={{height: 1, width: '100%', backgroundColor: '#CFCFCF'}} className="col-span-12 mt-3"></div> */}


        <div className="col-span-12 flex ">
            <Button
              type="outline"
              classes="w-1/2 mr-4"
              onClick={() => onCancel()}
              htmlType="button"
            >
              Cancelar
            </Button>

          <Button disabled={isLoading} loading={isLoading} type="primary" classes="w-1/2 mr-4" htmlType="submit">
            Guardar cambios
          </Button>
        </div>
 
    </Form>
  )
}

interface IInfoAccount {
    tenatUser: any
    onCancel: () => void
    onSubmit: (values) => void
    children: any
    isLoading: boolean
}

export default InfoAccount